import * as Collapsible from '@radix-ui/react-collapsible';
import cx from 'classnames';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { Typography } from '../../../design-system/components/typography/Typography';

import { CguContentDescription } from './CguContentDescription/CguContentDescription';
import style from './CguMention.module.css';

type Props = {
    isCollapsibleMention?: boolean;
    isShortMention?: boolean;
    shouldUseDataUsageLabel?: boolean;
    typographyScale?: 'primary-xxs-regular' | 'primary-xs-regular';
};

export function CguMention({
    isCollapsibleMention = false,
    isShortMention = false,
    shouldUseDataUsageLabel = false,
    typographyScale = 'primary-xxs-regular',
}: Props) {
    const { formatMessage } = useIntl();

    const [dataPolicyVisible, setDataPolicyVisible] = useState(false);

    return isCollapsibleMention ? (
        <>
            <Typography scale={typographyScale} as="p">
                {formatMessage({
                    id: shouldUseDataUsageLabel
                        ? 'global.component.cguMention.dataUsage.label'
                        : 'global.component.cguMention.accountCreation.label',
                })}
            </Typography>
            <Collapsible.Root
                open={dataPolicyVisible}
                onOpenChange={setDataPolicyVisible}
                className={style.dataPolicyCollapsible}
            >
                <Collapsible.Trigger
                    className={cx(
                        'link',
                        style.dataPolicyCollapsibleTitle,
                        typographyScale === 'primary-xxs-regular'
                            ? 'font-xxs-bold'
                            : 'font-xs-bold',
                    )}
                >
                    {formatMessage({
                        id: 'global.component.cguMention.trigger.label',
                    })}
                </Collapsible.Trigger>
                <Collapsible.Content className={style.dataPolicyCollapsibleContent}>
                    <CguContentDescription typographyScale={typographyScale} />
                </Collapsible.Content>
            </Collapsible.Root>
        </>
    ) : (
        <CguContentDescription isShortMention={isShortMention} typographyScale={typographyScale} />
    );
}
